const aggregateTime = {};
const aggregateCount = {};
export const timer = (name) => {
    const now = Date.now();
    return () => {
        if (aggregateTime[name] === undefined) {
            aggregateTime[name] = 0;
        }
        if (aggregateCount[name] === undefined) {
            aggregateCount[name] = 0;
        }
        aggregateTime[name] += Date.now() - now;
        aggregateCount[name] += 1;
    };
};
export const reportTimers = () => {
    Object.entries(aggregateTime).forEach(([name, duration]) => {
        const count = aggregateCount[name];
        console.log(`${name} - Total Time: ${duration}ms. Count: ${count}. Avg: ${duration / count}ms`);
    });
    setTimeout(reportTimers, 10000);
};

//# sourceMappingURL=timer.js.map
